import { render, staticRenderFns } from "./sign-wheel.vue?vue&type=template&id=2111fdd1&scoped=true&"
import script from "./sign-wheel.vue?vue&type=script&lang=ts&"
export * from "./sign-wheel.vue?vue&type=script&lang=ts&"
import style0 from "./sign-wheel.vue?vue&type=style&index=0&id=2111fdd1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2111fdd1",
  null
  
)

export default component.exports